import IcoMoon from "react-icomoon";
import iconSet from "../../assets/icons/selection.json";

interface IconProps {
  icon: string;
  className?: string;
  onClick?: () => void;
}

export default function Icon({ icon, className = "", onClick }: IconProps) {
  return (
    <IcoMoon
      iconSet={iconSet}
      icon={icon}
      className={`inline-block ${className} `}
      onClick={onClick}
    />
  );
}
